export const GITLAB_TOKEN_SESSION_KEY = 'gitlabToken';

export const GITLAB_OAUTH_SCOPES = ['read_user', 'read_repository'] as const;

export const GITLAB_OAUTH_STATE_KEY = 'gitlab_oauth_state';
